var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3071 16.0001H1.69296C0.757968 16.0001 0 15.1108 0 14.0139V1.98626C0 0.889237 0.757968 0 1.69296 0H6.70445L8.90911 1.78607H18.3071C19.2421 1.78607 20 2.6754 20 3.77243V14.0139C20 15.1108 19.2421 16.0001 18.3071 16.0001Z",
    fill: "#2F92CE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.9256 18.5559H1.07409C0.676178 18.5559 0.353516 18.1775 0.353516 17.7105V3.71646C0.353516 3.24958 0.676178 2.87109 1.07409 2.87109H18.9256C19.3235 2.87109 19.6462 3.24958 19.6462 3.71646V17.7105C19.6462 18.1775 19.3235 18.5559 18.9256 18.5559Z",
    fill: "#FFEFE9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.8074 18.272L1.13851 18.2498C0.744665 18.2493 0.425645 17.8744 0.426066 17.4122L0.438691 3.56132C0.439112 3.09923 0.758815 2.72501 1.15266 2.7255L18.8216 2.74767C19.2154 2.74817 19.5344 3.12319 19.534 3.58528L19.5214 17.4362C19.521 17.8983 19.2012 18.2725 18.8074 18.272Z",
    fill: "#FFEFE9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3071 20.0002H1.69296C0.757968 20.0002 0 19.1108 0 18.0139V5.72659C0 4.62956 0.757968 3.74023 1.69296 3.74023H18.3071C19.2421 3.74023 20 4.62956 20 5.72659V18.0139C20 19.1108 19.2421 20.0002 18.3071 20.0002Z",
    fill: "#64CAFB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.64453 14.8359V16.2359C5.64453 17.0242 6.18916 17.6632 6.86094 17.6632H13.1387C13.8106 17.6632 14.3553 17.0242 14.3553 16.2359V14.8359",
    stroke: "#0F68A3",
    strokeWidth: 1.82869,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.96019 10.1294H7.74703C7.47309 10.1294 7.3101 9.77066 7.46276 9.50389L8.55288 7.59886L9.40938 6.10199C9.69164 5.60861 10.3101 5.60861 10.5924 6.10199L11.4489 7.59886L12.5389 9.50389C12.6917 9.77066 12.5287 10.1294 12.2547 10.1294H11.0388V13.4746H8.96019V10.1294Z",
    fill: "#0F68A3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.9585 13.9102H11.0371V14.8516H8.9585V13.9102Z",
    fill: "#0F68A3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.9585 15.3182H11.0371V15.7637H8.9585V15.3182Z",
    fill: "#0F68A3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalFolderIcon);
export default __webpack_public_path__ + "static/media/local-folder-icon.89927133de1db8041d2b2632d3b2f553.svg";
export { ForwardRef as ReactComponent };